<script>
  // Перенос src_ui/web/src/screens/Characters.tsx — ДОСЛОВНО (инлайн-стили скопированы строками).
  import { nuiPost } from './nui';

  export let chars = [];
  export let slots = 3;
  /** состояние каждого слота: 'char' — занят, 'free' — свободен, 'locked' — не куплен */
  export let slotStates = undefined;
  export let username = null;
  export let onPlay = () => {};
  export let onCreate = () => {};

  const fmt = (n) => Math.round(n).toLocaleString('ru-RU').replace(/,/g, ' ');
  const fullName = (c) => `${c.identity.firstName} ${c.identity.lastName}`;
  const initial = (c) => (c.identity.firstName[0] ?? '?').toUpperCase();

  function ago(ts) {
    if (!ts) return 'впервые';
    const d = Date.now() - ts;
    if (d < 60_000) return 'только что';
    if (d < 3_600_000) return Math.floor(d / 60_000) + ' мин назад';
    if (d < 86_400_000) return Math.floor(d / 3_600_000) + ' ч назад';
    return Math.floor(d / 86_400_000) + ' дн назад';
  }

  const C = {
    gold: '#e0a83e', goldHi: '#ecb44c', goldLo: '#c97e2c', onGold: '#241a06',
    panelA: 'rgba(22,18,14,0.94)', panelB: 'rgba(13,11,9,0.93)',
    line: 'rgba(255,255,255,0.09)', lineSoft: 'rgba(255,255,255,0.06)',
    ink: '#fff', ink2: 'rgba(255,255,255,0.62)', ink3: 'rgba(255,255,255,0.4)',
  };
  const panelBg = `linear-gradient(135deg, ${C.panelA}, ${C.panelB})`;
  const goldGrad = `linear-gradient(135deg, ${C.goldHi}, ${C.goldLo})`;

  let sel = 0;
  let hover = null;

  // оживляем выбранного персонажа на сцене (useEffect [sel, chars.length])
  const preview = (c) => {
    if (c) nuiPost('previewChar', { idx: c.idx, appearance: c.appearance, gender: c.identity.gender });
  };
  let _pSel = -1, _pLen = -1;
  $: if (sel !== _pSel || chars.length !== _pLen) {
    _pSel = sel; _pLen = chars.length;
    preview(chars[sel]);
  }

  const select = (i) => { if (chars[i]) sel = i; };
  const cycle = (dir) => { if (chars.length) sel = (sel + dir + chars.length) % chars.length; };
  $: cur = chars[sel];

  // клавиши ← → Enter
  const onKey = (e) => {
    if (!chars.length) return;
    if (e.key === 'ArrowLeft') sel = (sel - 1 + chars.length) % chars.length;
    else if (e.key === 'ArrowRight') sel = (sel + 1) % chars.length;
    else if (e.key === 'Enter' && chars[sel]) onPlay(chars[sel]);
  };

  $: slotList = Array.from({ length: slots }, (_, i) => chars[i] ?? null);
</script>

<svelte:window on:keydown={onKey} />

<div style="position:fixed;inset:0;font-family:'Manrope',sans-serif;animation:lcFadeIn 0.5s ease">
  <!-- вигнетки для читаемости поверх живой сцены -->
  <div style="position:absolute;inset:0;pointer-events:none;background:linear-gradient(90deg, rgba(7,8,11,0.92) 0%, rgba(7,8,11,0.5) 24%, transparent 48%)"></div>
  <div style="position:absolute;inset:0;pointer-events:none;background:linear-gradient(0deg, rgba(6,7,10,0.9) 0%, rgba(6,7,10,0.35) 26%, transparent 52%)"></div>

  <!-- верхняя кромка -->
  <div style="position:absolute;top:36px;left:56px;right:56px;display:flex;align-items:center;justify-content:space-between">
    <div style="display:flex;align-items:center;gap:13px">
      <div style="width:42px;height:42px;border-radius:12px;background:{goldGrad};display:flex;align-items:center;justify-content:center;font:800 19px 'Unbounded';color:{C.onGold};box-shadow:0 6px 20px rgba(224,168,62,0.4)">J</div>
      <div style="font:700 18px 'Unbounded';color:#fff;letter-spacing:0.04em">JUST <span style="color:{C.gold}">RP</span></div>
    </div>
    <div style="display:flex;align-items:center;gap:9px;padding:9px 16px;border-radius:999px;background:{panelBg};border:1px solid {C.line}">
      <span style="width:8px;height:8px;border-radius:50%;background:#4fc483;box-shadow:0 0 8px rgba(79,196,131,0.7)"></span>
      <span style="font:600 13px 'Manrope';color:{C.ink2}">Social Club · <b style="color:{C.gold}">{(username ?? 'игрок').toUpperCase()}</b></span>
    </div>
  </div>

  <!-- ростер слева -->
  <div style="position:absolute;left:56px;top:128px;width:384px;display:flex;flex-direction:column;gap:14px">
    <div style="display:flex;align-items:baseline;justify-content:space-between;margin-bottom:2px">
      <div style="font:700 13px 'Manrope';letter-spacing:0.22em;text-transform:uppercase;color:{C.ink3}">Ваши персонажи</div>
      <div style="font:800 13px 'Unbounded';color:{C.gold}">{chars.length} / {slots}</div>
    </div>
    {#each slotList as c, i (i)}
      {#if c}
        <div on:click={() => select(i)} style="position:relative;display:flex;align-items:center;gap:15px;padding:17px 18px;border-radius:20px;background:{i === sel ? `linear-gradient(135deg, rgba(40,32,18,0.95), rgba(20,16,11,0.93))` : panelBg};border:1px solid {i === sel ? 'rgba(224,168,62,0.6)' : C.line};cursor:pointer;transition:all 0.18s;overflow:hidden">
          {#if i === sel}<div style="position:absolute;left:0;top:12px;bottom:12px;width:4px;border-radius:0 4px 4px 0;background:{goldGrad};box-shadow:0 0 12px rgba(224,168,62,0.6)"></div>{/if}
          <div style="width:54px;height:54px;border-radius:15px;flex-shrink:0;display:flex;align-items:center;justify-content:center;font:800 22px 'Unbounded';color:{c.identity.gender === 'f' ? '#fff' : C.onGold};background:{c.identity.gender === 'f' ? 'linear-gradient(135deg, #7d8aa0, #4a556a)' : goldGrad}">{initial(c)}</div>
          <div style="flex:1;min-width:0">
            <div style="font:700 16.5px 'Manrope';color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">{fullName(c)}</div>
            <div style="display:flex;align-items:center;gap:7px;margin-top:4px;font:600 12px 'Manrope';color:{C.ink3}">
              <span style="color:{C.gold};font-weight:800">УР {c.level ?? 1}</span>
              <span style="width:3px;height:3px;border-radius:50%;background:{C.ink3}"></span>
              <span>{c.org ? c.org.name : 'Гражданин'}</span>
            </div>
          </div>
          <div style="color:{C.ink3};font-size:18px">{i === sel ? '●' : ''}</div>
        </div>
      {:else if slotStates?.[i] === 'locked'}
        <!-- слот не куплен: раньше он выглядел как обычный «создать», и отказ
             приходил уже от сервера — после заполнения всей анкеты -->
        <div title="Слот открывается за донат" style="display:flex;align-items:center;gap:12px;padding:20px 18px;border-radius:20px;border:1px dashed rgba(255,255,255,0.10);background:rgba(255,255,255,0.015);cursor:not-allowed;opacity:0.62">
          <div style="width:38px;height:38px;border-radius:11px;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,0.05);border:1px solid {C.line};color:{C.ink3}">
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="4" y="11" width="16" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" />
            </svg>
          </div>
          <div>
            <div style="font:700 14px 'Manrope';color:{C.ink2}">Слот закрыт</div>
            <div style="font:600 12px 'Manrope';color:{C.ink3};margin-top:3px">Открывается за донат</div>
          </div>
        </div>
      {:else}
        <div on:click={onCreate} style="display:flex;align-items:center;justify-content:center;gap:12px;padding:22px 18px;border-radius:20px;border:1px dashed rgba(255,255,255,0.16);background:rgba(255,255,255,0.02);cursor:pointer">
          <div style="width:38px;height:38px;border-radius:11px;display:flex;align-items:center;justify-content:center;background:rgba(224,168,62,0.14);border:1px solid rgba(224,168,62,0.3);color:{C.gold};font-size:22px;font-weight:300">+</div>
          <div style="font:700 14px 'Manrope';color:{C.ink2}">Создать персонажа</div>
        </div>
      {/if}
    {/each}
  </div>

  <!-- стрелки перелистывания — симметричной парой по краям экрана, на уровне
       имени героя (список персонажей выше и не мешает) -->
  {#if chars.length > 1}
    {#each ['L', 'R'] as d (d)}
      <div
        on:click={() => cycle(d === 'L' ? -1 : 1)}
        on:mouseenter={() => { hover = d; }}
        on:mouseleave={() => { hover = null; }}
        title={d === 'L' ? 'Предыдущий персонаж (←)' : 'Следующий персонаж (→)'}
        style="position:absolute;top:68%;z-index:6;{d === 'L' ? 'left' : 'right'}:72px;width:64px;height:64px;border-radius:50%;display:flex;align-items:center;justify-content:center;background:{hover === d ? goldGrad : panelBg};border:1px solid {hover === d ? 'transparent' : 'rgba(224,168,62,0.35)'};box-shadow:{hover === d ? '0 12px 34px rgba(224,168,62,0.45)' : '0 10px 30px rgba(0,0,0,0.45)'};color:{hover === d ? C.onGold : '#fff'};cursor:pointer;transition:all 0.18s"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round">
          <path d={d === 'L' ? 'M15 6l-6 6 6 6' : 'M9 6l6 6-6 6'} />
        </svg>
      </div>
    {/each}
  {/if}

  <!-- герой по центру снизу -->
  {#if cur}
    <div style="position:absolute;left:0;right:0;bottom:56px;display:flex;flex-direction:column;align-items:center;text-align:center">
      <div style="display:inline-flex;align-items:center;gap:9px;padding:8px 16px;border-radius:999px;background:{panelBg};border:1px solid rgba(224,168,62,0.3);margin-bottom:18px">
        <span style="font:700 12px 'Manrope';letter-spacing:0.16em;text-transform:uppercase;color:#fff">{cur.org ? `${cur.org.name} · ${cur.org.role}` : 'Гражданин Лос-Сантоса'}</span>
      </div>
      <div style="font:800 60px 'Unbounded';color:#fff;letter-spacing:0.01em;line-height:1;text-shadow:0 6px 40px rgba(0,0,0,0.6)">{fullName(cur)}</div>
      <div style="display:flex;margin-top:26px;border-radius:18px;background:{panelBg};border:1px solid {C.line};overflow:hidden">
        <div style="padding:16px 28px;display:flex;flex-direction:column;gap:5px;min-width:124px">
          <div style="font:700 10.5px 'Manrope';letter-spacing:0.14em;text-transform:uppercase;color:{C.ink3}">Наличные</div>
          <div style="font:700 22px 'Unbounded';color:{C.gold}">${fmt(cur.cash)}</div>
        </div>
        {#each [
          { k: 'Банк', v: '$' + fmt(cur.bank), small: false },
          { k: 'В игре', v: (cur.hours ?? 0) + ' ч', small: false },
          { k: 'Был в сети', v: ago(cur.lastSeen), small: true },
        ] as s (s.k)}
          <div style="padding:16px 28px;display:flex;flex-direction:column;gap:5px;min-width:124px;border-left:1px solid {C.lineSoft}">
            <div style="font:700 10.5px 'Manrope';letter-spacing:0.14em;text-transform:uppercase;color:{C.ink3}">{s.k}</div>
            <div style="font:{s.small ? `700 16px 'Manrope'` : `700 22px 'Unbounded'`};color:#fff">{s.v}</div>
          </div>
        {/each}
      </div>
      <div style="display:flex;align-items:center;gap:14px;margin-top:30px">
        <button on:click={() => onPlay(cur)} style="display:inline-flex;align-items:center;gap:11px;padding:19px 54px;border-radius:15px;border:none;cursor:pointer;background:{goldGrad};color:{C.onGold};font:700 16px 'Unbounded';letter-spacing:0.08em;text-transform:uppercase;box-shadow:0 14px 38px rgba(224,168,62,0.42)"><span style="display:inline-flex;align-items:center;justify-content:center;min-width:22px;height:22px;padding:0 6px;border-radius:7px;background:rgba(36,26,6,0.24);font:800 11px 'Unbounded'">↵</span> Играть</button>
      </div>
    </div>
  {/if}
</div>
